var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox as MuiCheckbox } from "@mui/material";
import { COLORS, HALO } from "../../../../constants";
var checkboxSxProps = {
    color: COLORS.BLACK,
    p: 1.5,
    "&.Mui-disabled": {
        color: COLORS.P_DISABLED,
        "&.Mui-checked": {
            color: COLORS.PERIWINKLE,
        },
    },
    ".MuiSvgIcon-root": {
        fontSize: "20px",
    },
    "input:focus-visible ~ .MuiTouchRipple-root": {
        boxShadow: HALO,
        span: {
            background: "none",
        },
    },
    "&:hover": {
        bgcolor: COLORS.BLACK_OVERLAY_HOVER,
    },
    "&:active": {
        bgcolor: COLORS.BLACK_OVERLAY_PRESSED,
    },
    "&.Mui-checked, &.MuiCheckbox-indeterminate": {
        color: "primary.main",
        "&:hover": {
            bgcolor: COLORS.OVERLAY_HOVER,
        },
        "&:active": {
            bgcolor: COLORS.OVERLAY_PRESSED,
        },
    },
};
var Checkbox = function (_a) {
    var name = _a.name, rest = __rest(_a, ["name"]);
    return (_jsx(MuiCheckbox, __assign({ sx: checkboxSxProps, "data-testid": name, color: "default", name: name }, rest)));
};
export default Checkbox;
